<template>
  <div style="display: flex; align-items: center;">
    <div style="padding: 0 1rem 0 1rem">
      <translate>Public.sort.by</translate>
    </div>
    <b-select v-model="localSortField" style="padding: 0 1rem 0 1rem">
      <option
        :value="value.field"
        v-for="value in sortFields"
        :key="`${resourceType}.${value.field}`"
      >
        <translate>{{value.label}}</translate>
      </option>
    </b-select>
    <b-select v-model="localSortOrder">
      <option value="ASC">
        <translate>Public.sort.order.ASC</translate>
      </option>
      <option translate value="DESC">
        <translate>Public.sort.order.DESC</translate>
      </option>
    </b-select>
  </div>
</template>

<script>

export default {
  name: 'fob-public-list-sort',
  props: ['resourceType', 'sortField', 'sortFields', 'sortOrder'],
  computed: {
    localSortField: {
      get () {
        return this.sortField
      },
      set (newSortField) {
        this.onSortFieldChange(newSortField)
        return newSortField
      }
    },
    localSortOrder: {
      get () {
        return this.sortOrder
      },
      set (newSortOrder) {
        this.onSortOrderChange(newSortOrder)
        return newSortOrder
      }
    }
  },
  methods: {
    onSortFieldChange (sortField) {
      this.$emit('update:sortFieldPublicView', sortField)
    },
    onSortOrderChange (sortOrder) {
      this.$emit('update:sortOrderPublicView', sortOrder)
    }
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/public/PublicListSort.vue